module.exports = __webpack_public_path__ + "media/assets/images/app-icon-16278f696670f530614a7cfa4f0c64b1.png";